/* ==========================================================================
   HMC — cart drawer quick-add (Complete your kit)
   Adds the variant via the Cart Ajax API (with Section Rendering so the
   response carries fresh header-section HTML), then dispatches Horizon's
   native `cart:update` event. cart-items-component morphs the drawer,
   cart-icon updates the bubble — zero custom re-render logic to maintain.
   Delegated listener survives section morphs.
   ========================================================================== */
(function () {
  'use strict';

  let busy = false;

  // variant <select> next to a quick-add button: keep the button's
  // target variant in sync so Add posts what the customer chose
  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-hmc-variant-select]');
    if (!select || !select.value) return;
    const scope = select.closest('[data-hmc-buy]');
    const btn = scope && scope.querySelector('[data-hmc-add]');
    if (btn) btn.dataset.hmcAdd = select.value;
  });

  document.addEventListener('click', async function (event) {
    const btn = event.target.closest('[data-hmc-add]');
    if (!btn || busy) return;

    event.preventDefault();
    busy = true;
    btn.classList.add('is-loading');
    btn.disabled = true;

    const sectionId = btn.closest('[data-hmc-section]')?.dataset.hmcSection;
    const payload = {
      id: Number(btn.dataset.hmcAdd),
      quantity: 1,
    };
    if (sectionId) {
      payload.sections = sectionId;
      payload.sections_url = window.location.pathname;
    }

    try {
      const url =
        (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Add to cart failed');
      }

      // Hand off to Horizon: morphs drawer + bubble from data.sections,
      // or re-fetches the section if sections are absent.
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: 'hmc-cart-upsell',
            data: {
              source: 'hmc-cart-upsell',
              variantId: String(payload.id),
              sections: data.sections || undefined,
            },
          },
        })
      );
      // Inside the drawer the morph replaces the button; in on-page grids it
      // persists — reset it and flash an "added" state (harmless if detached).
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1600);
    } catch (err) {
      console.error('[HMC upsell]', err);
      btn.classList.remove('is-loading');
      btn.disabled = false;
      btn.classList.add('is-error');
      setTimeout(() => btn.classList.remove('is-error'), 1600);
    } finally {
      busy = false;
    }
  });
})();